import type { IconName } from '@/components/entities/Sprite/Icon';
import { useId } from 'react';
import { cn } from '@/utils/cn';

interface Props {
  iconName: IconName;
  durationSeconds?: number;
  travelDistance?: number;
  rotateOrigin?: string;
  className?: string;
}

const GlareSweep = ({
  iconName,
  durationSeconds = 4,
  travelDistance = 200,
  rotateOrigin = '50 50',
  className,
}: Props) => {
  const rawId = useId().replace(/:/g, '');

  const firstGradientId = `${rawId}-first`;
  const secondGradientId = `${rawId}-second`;
  const maskId = `${rawId}-mask`;

  return (
    <svg
      aria-hidden
      className={cn(
        'pointer-events-none absolute inset-0 h-full w-full',
        className,
      )}
    >
      <defs>
        <linearGradient id={firstGradientId} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0.06" stopColor="#F9E938" stopOpacity="0" />
          <stop offset="0.18" stopColor="#F9E938" stopOpacity="0.35" />

          <stop offset="0.30" stopColor="#F9E938" stopOpacity="0.95" />
          <stop offset="0.46" stopColor="#F9E938" stopOpacity="0.95" />

          <stop offset="0.60" stopColor="#F9E938" stopOpacity="0.35" />
          <stop offset="0.74" stopColor="#F9E938" stopOpacity="0" />
        </linearGradient>

        <linearGradient id={secondGradientId} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0.64" stopColor="#F9E938" stopOpacity="0" />
          <stop offset="0.72" stopColor="#F9E938" stopOpacity="0.35" />

          <stop offset="0.78" stopColor="#F9E938" stopOpacity="0.9" />
          <stop offset="0.86" stopColor="#F9E938" stopOpacity="0.9" />

          <stop offset="0.92" stopColor="#F9E938" stopOpacity="0.35" />
          <stop offset="0.98" stopColor="#F9E938" stopOpacity="0" />
        </linearGradient>

        <mask id={maskId} style={{ maskType: 'alpha' }}>
          <use xlinkHref={`#icon-${iconName}`} />
        </mask>
      </defs>

      <g mask={`url(#${maskId})`}>
        <rect
          x="-100%"
          y="-100%"
          width="100%"
          height="300%"
          fill={`url(#${firstGradientId})`}
          transform={`rotate(-30 ${rotateOrigin})`}
        >
          <animateTransform
            attributeName="transform"
            additive="sum"
            type="translate"
            values={`-${travelDistance} 0; ${travelDistance} 0`}
            dur={`${durationSeconds}s`}
            repeatCount="indefinite"
          />
        </rect>

        <rect
          x="-100%"
          y="-100%"
          width="100%"
          height="300%"
          fill={`url(#${secondGradientId})`}
          transform={`rotate(-30 ${rotateOrigin})`}
        >
          <animateTransform
            attributeName="transform"
            additive="sum"
            type="translate"
            values={`-${travelDistance} 0; ${travelDistance} 0`}
            dur={`${durationSeconds}s`}
            repeatCount="indefinite"
          />
        </rect>
      </g>
    </svg>
  );
};

export default GlareSweep;
